import { Visio2Api } from './visio2.api.types';

export * from './visio2.api.types'
export * from './visio2.api.vue_mixins'


let apiMap = new Map<String, Function>();


export function registerApi(key: String, apiPromise: Function) {
    apiMap.set(key, apiPromise)
}

let api:Visio2Api
let apiRequests: Function[] = []
export async function getApi(key: String): Promise<Visio2Api> {
    return apiMap.get(key)?.()
}